<div class="report-wizard">
  @if (typesLoadError) {
  <p class="types-warning">{{ typesLoadError }}</p>
  } @if (selectedTypeDef) {
  <div class="wizard-layout">
    <mat-horizontal-stepper #stepper class="wizard-stepper">
      <!-- Step 1: Report type -->
      <mat-step label="Rapporttype">
        <div class="step-content">
          <h2>Vælg rapporttype</h2>
          <div class="type-grid">
            @for (t of reportTypes; track t.id) {
            <mat-card
              class="type-card"
              [class.selected]="config.report_type === t.id"
              (click)="selectReportType(t)"
            >
              <mat-card-header>
                <mat-icon mat-card-avatar>{{
                  t.category === "simple"
                    ? "speed"
                    : t.category === "minimal"
                    ? "bar_chart"
                    : "description"
                }}</mat-icon>
                <mat-card-title>{{ t.name }}</mat-card-title>
                <mat-card-subtitle>
                  <span
                    class="badge"
                    [class.simple]="
                      t.category === 'simple' || t.category === 'minimal'
                    "
                    >{{
                      t.category === "simple"
                        ? "Simpel"
                        : t.category === "minimal"
                        ? "Minimal"
                        : "Detaljeret"
                    }}</span
                  >
                </mat-card-subtitle>
              </mat-card-header>
              <mat-card-content
                ><p>{{ t.description }}</p></mat-card-content
              >
            </mat-card>
            }
          </div>
          <mat-expansion-panel class="sections-panel" expanded>
            <mat-expansion-panel-header
              ><mat-panel-title
                >Sektioner i rapporten</mat-panel-title
              ></mat-expansion-panel-header
            >
            <div class="checkbox-grid">
              @for (s of selectedTypeDef.sections; track s.id) {
              <mat-checkbox
                [checked]="isSectionEnabled(s.id)"
                (change)="toggleSection(s.id, $event.checked)"
              >
                {{ s.label }}
              </mat-checkbox>
              }
            </div>
          </mat-expansion-panel>
        </div>
        <div class="step-actions">
          <button mat-button matStepperNext color="primary">Næste</button>
        </div>
      </mat-step>
      <!-- Step 2: Paths -->
      <mat-step label="Uddannelsesveje">
        <div class="step-content">
          <h2>Uddannelsesveje</h2>
          <div class="list-toolbar">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Søg uddannelsesvej</mat-label>
              <input
                matInput
                [(ngModel)]="pathSearch"
                (ngModelChange)="onPathSearchChange()"
              />
            </mat-form-field>
            <mat-checkbox
              class="select-all-checkbox"
              [checked]="allPathsSelected"
              [indeterminate]="!allPathsSelected && config.path_ids.length > 0"
              (change)="toggleAllPaths($event.checked)"
              >Alle uddannelsesveje ({{ availablePaths.length }})</mat-checkbox
            >
          </div>
          @if (!allPathsSelected && config.path_ids.length === 0) {
          <p class="hint">
            Vælg mindst én uddannelsesvej, eller markér «Alle uddannelsesveje».
          </p>
          }
          @if (showPathVersionChoice) {
          <div class="version-mode-block">
            <p class="hint">Valgte uddannelsesveje har flere versioner med forskellige moduler.</p>
            <mat-radio-group
              [(ngModel)]="config.path_version_mode"
              (ngModelChange)="onPathVersionModeChange()"
            >
              <mat-radio-button value="grouped"
                >Gruppér versioner (samlet modulliste)</mat-radio-button
              >
              <mat-radio-button value="separated"
                >Vis hver version for sig</mat-radio-button
              >
            </mat-radio-group>
          </div>
          }
          <div class="checkbox-list">
            @for (p of paginatedPaths; track p.guid) {
            <mat-checkbox
              [checked]="isPathSelected(resolvePathId(p))"
              (change)="togglePath(resolvePathId(p), $event.checked)"
              >{{ p.name || p.full_name }}</mat-checkbox
            >
            }
          </div>
          @if (filteredPaths.length > 0) {
          <div class="list-pager">
            <span class="pager-info"
              >Viser {{ pathRangeStart }}–{{ pathRangeEnd }} af
              {{ filteredPaths.length }}</span
            >
            <div class="pager-controls">
              <button
                mat-stroked-button
                type="button"
                [disabled]="pathPageIndex === 0"
                (click)="setPathPage(pathPageIndex - 1)"
              >
                Forrige
              </button>
              <span class="pager-page"
                >Side {{ pathPageIndex + 1 }} / {{ pathTotalPages }}</span
              >
              <button
                mat-stroked-button
                type="button"
                [disabled]="pathPageIndex >= pathTotalPages - 1"
                (click)="setPathPage(pathPageIndex + 1)"
              >
                Næste
              </button>
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="page-size-field"
              >
                <mat-label>Pr. side</mat-label>
                <mat-select
                  [(ngModel)]="pathPageSize"
                  (selectionChange)="onPathPageSizeChange()"
                >
                  @for (s of pageSizeOptions; track s) {
                  <mat-option [value]="s">{{ s }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          }
        </div>
        <div class="step-actions">
          <button mat-button matStepperPrevious>Tilbage</button>
          <button mat-button matStepperNext color="primary">Næste</button>
        </div>
      </mat-step>
      <!-- Step 3: Modules -->
      <mat-step label="Moduler">
        <div class="step-content">
          <h2>Moduler</h2>
          @if (allPathsSelected) {
          <p class="hint">
            Alle moduler på organisationens uddannelsesveje vises.
          </p>
          } @if (!allPathsSelected && config.path_ids.length > 0) {
          <p class="hint">
            Kun moduler på vedligeholdelse for valgte uddannelsesveje vises.
          </p>
          } @if (!allPathsSelected && config.path_ids.length === 0) {
          <p class="hint">
            Vælg uddannelsesveje i forrige trin for at se moduler.
          </p>
          } @if (loadingModules) {
          <mat-spinner diameter="32"></mat-spinner>
          } @if (!loadingModules) {
          <div class="list-toolbar">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Søg modul</mat-label>
              <input
                matInput
                [(ngModel)]="moduleSearch"
                (ngModelChange)="onModuleSearchChange()"
              />
            </mat-form-field>
            <mat-checkbox
              class="select-all-checkbox"
              [checked]="allModulesSelected"
              [indeterminate]="
                !allModulesSelected && config.module_ids.length > 0
              "
              (change)="toggleAllModules($event.checked)"
              >Alle moduler ({{ availableModules.length }})</mat-checkbox
            >
          </div>
          <div class="checkbox-list">
            @for (m of paginatedModules; track m.module_id) {
            <mat-checkbox
              [checked]="isModuleSelected(m.module_id)"
              (change)="toggleModule(m.module_id, $event.checked)"
            >
              {{ m.name }}@if (m.required) {
              <span class="req-tag"> (påkrævet)</span>
              }
            </mat-checkbox>
            }
          </div>
          @if (filteredModules.length > 0) {
          <div class="list-pager">
            <span class="pager-info"
              >Viser {{ moduleRangeStart }}–{{ moduleRangeEnd }} af
              {{ filteredModules.length }}</span
            >
            <div class="pager-controls">
              <button
                mat-stroked-button
                type="button"
                [disabled]="modulePageIndex === 0"
                (click)="setModulePage(modulePageIndex - 1)"
              >
                Forrige
              </button>
              <span class="pager-page"
                >Side {{ modulePageIndex + 1 }} / {{ moduleTotalPages }}</span
              >
              <button
                mat-stroked-button
                type="button"
                [disabled]="modulePageIndex >= moduleTotalPages - 1"
                (click)="setModulePage(modulePageIndex + 1)"
              >
                Næste
              </button>
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="page-size-field"
              >
                <mat-label>Pr. side</mat-label>
                <mat-select
                  [(ngModel)]="modulePageSize"
                  (selectionChange)="onModulePageSizeChange()"
                >
                  @for (s of pageSizeOptions; track s) {
                  <mat-option [value]="s">{{ s }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          } }
        </div>
        <div class="step-actions">
          <button mat-button matStepperPrevious>Tilbage</button>
          <button mat-button matStepperNext color="primary">Næste</button>
        </div>
      </mat-step>
      <!-- Step 4: Locations -->
      @if (showLocations) {
      <mat-step label="Lokationer">
        <div class="step-content">
          <h2>Stationer / lokationer</h2>
          <div class="list-toolbar">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Søg lokation</mat-label>
              <input
                matInput
                [(ngModel)]="locationSearch"
                (ngModelChange)="onLocationSearchChange()"
              />
            </mat-form-field>
            <mat-checkbox
              class="select-all-checkbox"
              [checked]="allLocationsSelected"
              [indeterminate]="
                !allLocationsSelected && config.location_guids.length > 0
              "
              (change)="toggleAllLocations($event.checked)"
              >Alle stationer ({{ availableLocations.length }})</mat-checkbox
            >
          </div>
          @if (!allLocationsSelected && config.location_guids.length === 0) {
          <p class="hint">
            Vælg mindst én station, eller markér «Alle stationer».
          </p>
          }
          <div class="checkbox-list">
            @for (l of paginatedLocations; track l.guid) {
            <mat-checkbox
              [checked]="isLocationSelected(l.guid)"
              (change)="toggleLocation(l.guid, $event.checked)"
              >{{ l.name }}</mat-checkbox
            >
            }
          </div>
          @if (filteredLocations.length > 0) {
          <div class="list-pager">
            <span class="pager-info"
              >Viser {{ locationRangeStart }}–{{ locationRangeEnd }} af
              {{ filteredLocations.length }}</span
            >
            <div class="pager-controls">
              <button
                mat-stroked-button
                type="button"
                [disabled]="locationPageIndex === 0"
                (click)="setLocationPage(locationPageIndex - 1)"
              >
                Forrige
              </button>
              <span class="pager-page"
                >Side {{ locationPageIndex + 1 }} /
                {{ locationTotalPages }}</span
              >
              <button
                mat-stroked-button
                type="button"
                [disabled]="locationPageIndex >= locationTotalPages - 1"
                (click)="setLocationPage(locationPageIndex + 1)"
              >
                Næste
              </button>
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="page-size-field"
              >
                <mat-label>Pr. side</mat-label>
                <mat-select
                  [(ngModel)]="locationPageSize"
                  (selectionChange)="onLocationPageSizeChange()"
                >
                  @for (s of pageSizeOptions; track s) {
                  <mat-option [value]="s">{{ s }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          }
        </div>
        <div class="step-actions">
          <button mat-button matStepperPrevious>Tilbage</button>
          <button mat-button matStepperNext color="primary">Næste</button>
        </div>
      </mat-step>
      }
      @if (showGroups) {
      <mat-step label="Brugergrupper">
        <div class="step-content">
          <h2>Brugergrupper</h2>
          <div class="list-toolbar">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Søg gruppe</mat-label>
              <input
                matInput
                [(ngModel)]="groupSearch"
                (ngModelChange)="onGroupSearchChange()"
              />
            </mat-form-field>
            <mat-checkbox
              class="select-all-checkbox"
              [checked]="allGroupsSelected"
              [indeterminate]="
                !allGroupsSelected && config.group_ids.length > 0
              "
              (change)="toggleAllGroups($event.checked)"
              >Alle grupper ({{ availableGroups.length }})</mat-checkbox
            >
          </div>
          <div class="checkbox-list">
            @for (g of paginatedGroups; track g.group_id) {
            <mat-checkbox
              [checked]="isGroupSelected(g.group_id)"
              (change)="toggleGroup(g.group_id, $event.checked)"
              >{{ g.name }}</mat-checkbox
            >
            }
          </div>
          @if (filteredGroups.length > 0) {
          <div class="list-pager">
            <span class="pager-info"
              >Viser {{ groupRangeStart }}–{{ groupRangeEnd }} af
              {{ filteredGroups.length }}</span
            >
            <div class="pager-controls">
              <button
                mat-stroked-button
                type="button"
                [disabled]="groupPageIndex === 0"
                (click)="setGroupPage(groupPageIndex - 1)"
              >
                Forrige
              </button>
              <span class="pager-page"
                >Side {{ groupPageIndex + 1 }} / {{ groupTotalPages }}</span
              >
              <button
                mat-stroked-button
                type="button"
                [disabled]="groupPageIndex >= groupTotalPages - 1"
                (click)="setGroupPage(groupPageIndex + 1)"
              >
                Næste
              </button>
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="page-size-field"
              >
                <mat-label>Pr. side</mat-label>
                <mat-select
                  [(ngModel)]="groupPageSize"
                  (selectionChange)="onGroupPageSizeChange()"
                >
                  @for (s of pageSizeOptions; track s) {
                  <mat-option [value]="s">{{ s }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          }
        </div>
        <div class="step-actions">
          <button mat-button matStepperPrevious>Tilbage</button>
          <button mat-button matStepperNext color="primary">Næste</button>
        </div>
      </mat-step>
      }
      <!-- Step 5: Users -->
      <mat-step label="Brugere">
        <div class="step-content">
          <h2>Brugere</h2>
          <div class="list-toolbar">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Søg bruger</mat-label>
              <input
                matInput
                [(ngModel)]="userSearch"
                (ngModelChange)="onUserSearchChange()"
              />
            </mat-form-field>
            @if (!loadingUsers) {
            <mat-checkbox
              class="select-all-checkbox"
              [checked]="allUsersSelected"
              [indeterminate]="!allUsersSelected && config.user_ids.length > 0"
              (change)="toggleAllUsers($event.checked)"
              >Alle brugere ({{ availableUsers.length }})</mat-checkbox
            >
            }
          </div>
          @if (loadingUsers) {
          <mat-spinner diameter="32"></mat-spinner>
          } @if (!loadingUsers) {
          <div class="checkbox-list">
            @for (u of paginatedUsers; track u.id) {
            <mat-checkbox
              [checked]="isUserSelected(u.id)"
              (change)="toggleUser(u.id, $event.checked)"
              >{{ u.full_name }} ({{ u.email }})</mat-checkbox
            >
            }
          </div>
          @if (filteredUsers.length > 0) {
          <div class="list-pager">
            <span class="pager-info"
              >Viser {{ userRangeStart }}–{{ userRangeEnd }} af
              {{ filteredUsers.length }}</span
            >
            <div class="pager-controls">
              <button
                mat-stroked-button
                type="button"
                [disabled]="userPageIndex === 0"
                (click)="setUserPage(userPageIndex - 1)"
              >
                Forrige
              </button>
              <span class="pager-page"
                >Side {{ userPageIndex + 1 }} / {{ userTotalPages }}</span
              >
              <button
                mat-stroked-button
                type="button"
                [disabled]="userPageIndex >= userTotalPages - 1"
                (click)="setUserPage(userPageIndex + 1)"
              >
                Næste
              </button>
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="page-size-field"
              >
                <mat-label>Pr. side</mat-label>
                <mat-select
                  [(ngModel)]="userPageSize"
                  (selectionChange)="onUserPageSizeChange()"
                >
                  @for (s of pageSizeOptions; track s) {
                  <mat-option [value]="s">{{ s }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          } }
        </div>
        <div class="step-actions">
          <button mat-button matStepperPrevious>Tilbage</button>
          <button mat-button matStepperNext color="primary">Næste</button>
        </div>
      </mat-step>
      <!-- Step 6: Delivery -->
      <mat-step label="Levering">
        <div class="step-content">
          <h2>Levering og periode</h2>
          @if (showAdvisering) {
          <section class="advisering-settings">
            <mat-slide-toggle
              class="advisering-toggle"
              [checked]="config.delivery.advisering_enabled"
              (change)="toggleAdvisering($event.checked)"
              >Aktivér advisering (e-mail)</mat-slide-toggle
            >
            @if (config.delivery.advisering_enabled) {
            <div class="advisering-details">
              <mat-form-field
                appearance="outline"
                class="schedule-mode-field"
                subscriptSizing="dynamic"
              >
                <mat-label>Planlægning</mat-label>
                <mat-select [(ngModel)]="config.delivery.schedule_mode">
                  <mat-option value="before_expiry"
                    >Før udløb af vedligeholdelsesvindue</mat-option
                  >
                  <mat-option value="calendar">Fast kalenderinterval</mat-option>
                </mat-select>
              </mat-form-field>
              @if (config.delivery.schedule_mode === 'before_expiry') {
              <div class="intervals">
                <p class="interval-heading">Send advisering</p>
                @for (iv of config.delivery.advisory_intervals; track $index;
                let i = $index) {
                <div class="interval-row">
                  <mat-form-field appearance="outline"
                    ><input matInput type="number" [(ngModel)]="iv.value" min="1"
                  /></mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="iv.unit">
                      @for (u of intervalUnits; track u.value) {
                      <mat-option [value]="u.value">{{ u.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <span class="interval-suffix">før udløb</span>
                  @if (config.delivery.advisory_intervals.length > 1) {
                  <button mat-icon-button (click)="removeInterval(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                  }
                </div>
                }
                <button mat-stroked-button (click)="addInterval()">
                  <mat-icon>add</mat-icon> Tilføj interval
                </button>
              </div>
              } @if (config.delivery.schedule_mode === 'calendar') {
              <div class="intervals calendar-interval">
                <p class="interval-heading">Send rapporten</p>
                <div class="interval-row">
                  <span class="interval-prefix">Hver</span>
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="calendarInterval.value"
                      min="1"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="calendarInterval.unit">
                      @for (u of intervalUnits; track u.value) {
                      <mat-option [value]="u.value">{{ u.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              }
              <h3>Modtagere</h3>
              <div class="checkbox-list scrollable">
                @for (u of availableUsers; track u.id) {
                <mat-checkbox
                  [checked]="isRecipientSelected(u.id)"
                  (change)="toggleRecipient(u.id, $event.checked)"
                  >{{ u.full_name }}</mat-checkbox
                >
                }
              </div>
            </div>
            }
          </section>
          } @if (!config.delivery.advisering_enabled || !showAdvisering) {
          <h3>Data periode</h3>
          <mat-radio-group [(ngModel)]="config.delivery.date.mode">
            <mat-radio-button value="year">Kalenderår</mat-radio-button>
            <mat-radio-button value="range">Datointerval</mat-radio-button>
          </mat-radio-group>
          @if (config.delivery.date.mode === 'year') {
          <mat-form-field appearance="outline">
            <mat-label>År</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="config.delivery.date.year"
            />
          </mat-form-field>
          } @if (config.delivery.date.mode === 'range') {
          <div class="date-range">
            <mat-form-field appearance="outline"
              ><mat-label>Fra</mat-label
              ><input
                matInput
                type="date"
                [(ngModel)]="config.delivery.date.date_from"
            /></mat-form-field>
            <mat-form-field appearance="outline"
              ><mat-label>Til</mat-label
              ><input
                matInput
                type="date"
                [(ngModel)]="config.delivery.date.date_to"
            /></mat-form-field>
          </div>
          } }
        </div>
        <div class="step-actions">
          <button mat-button matStepperPrevious>Tilbage</button>
          <button mat-button matStepperNext color="primary">Næste</button>
        </div>
      </mat-step>
      <!-- Step 7: Dimensions -->
      <mat-step label="Dimensioner">
        <div class="step-content">
          <h2>
            {{
              selectedTypeDef.category === "minimal"
                ? "Indstillinger (lag og visning)"
                : "Dimensioner og diagrammer"
            }}
          </h2>
          <div class="checkbox-grid">
            @for (d of selectedTypeDef.dimensions; track d.id) {
            <mat-checkbox
              [checked]="isDimensionEnabled(d.id)"
              (change)="toggleDimension(d.id, $event.checked)"
              >{{ d.label }}</mat-checkbox
            >
            }
          </div>
          @if (selectedTypeDef.options?.length) {
          <div class="charts-section">
            <h3>Sortering</h3>
            @for (o of selectedTypeDef.options; track o.id) {
            <mat-form-field appearance="outline" class="option-field">
              <mat-label>{{ o.label }}</mat-label>
              <mat-select
                [ngModel]="optionValue(o.id)"
                (ngModelChange)="setOption(o.id, $event)"
              >
                @for (c of o.choices; track c.value) {
                <mat-option [value]="c.value">{{ c.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            }
          </div>
          } @if (selectedTypeDef.charts.length) {
          <div class="charts-section">
            <h3>Diagramtyper</h3>
            @for (c of selectedTypeDef.charts; track c.id) {
            <mat-checkbox
              [checked]="isChartEnabled(c.id)"
              (change)="toggleChart(c.id, $event.checked)"
              >{{ c.label }}</mat-checkbox
            >
            }
          </div>
          }
        </div>
        <div class="step-actions">
          <button mat-button matStepperPrevious>Tilbage</button>
          <button mat-button matStepperNext color="primary">Næste</button>
        </div>
      </mat-step>
      <!-- Step 8: Name / GDPR -->
      <mat-step label="Afslut">
        <div class="step-content">
          @if (canSaveReport) {
          <h2>Navn og gem</h2>
          <mat-form-field appearance="outline" class="full-width"
            ><mat-label>Navn</mat-label
            ><input matInput [(ngModel)]="name" required
          /></mat-form-field>
          <mat-form-field appearance="outline" class="full-width"
            ><mat-label>Beskrivelse (valgfri)</mat-label
            ><textarea matInput rows="3" [(ngModel)]="description"></textarea>
          </mat-form-field>
          } @if (showGdpr) {
          <h2>GDPR og generering</h2>
          <mat-checkbox [(ngModel)]="gdprAccepted">
            Jeg bekræfter at rapporten kun indeholder data for den valgte
            station og accepterer behandling af personoplysninger i rapporten.
          </mat-checkbox>
          }
        </div>
        <div class="step-actions">
          <button mat-button matStepperPrevious>Tilbage</button>
          @if (canSaveReport) {
          <button
            mat-raised-button
            color="primary"
            [disabled]="isSaving"
            (click)="saveReport()"
          >
            @if (isSaving) {
            <mat-spinner diameter="20"></mat-spinner>
            } @if (!isSaving) {
            <span>Gem rapport</span>
            }
          </button>
          } @if (showGdpr) {
          <button
            mat-raised-button
            color="accent"
            [disabled]="isGenerating || !gdprAccepted"
            (click)="generateReport()"
          >
            @if (isGenerating) {
            <mat-spinner diameter="20"></mat-spinner>
            } @if (!isGenerating) {
            <span>Generer og download</span>
            }
          </button>
          }
        </div>
      </mat-step>
    </mat-horizontal-stepper>
    <aside class="summary-sidebar">
      <h3>Opsummering</h3>
      <dl>
        <dt>Type</dt>
        <dd>{{ summaryTypeName() }}</dd>
        <dt>Uddannelsesveje</dt>
        <dd>{{ summaryPaths() }}</dd>
        @if (showPathVersionChoice) {
        <dt>Versioner</dt>
        <dd>{{ summaryPathVersions() }}</dd>
        }
        <dt>Moduler</dt>
        <dd>{{ summaryModules() }}</dd>
        <dt>Lokation</dt>
        <dd>{{ summaryLocations() }}</dd>
        @if (showGroups) {
        <dt>Grupper</dt>
        <dd>{{ summaryGroups() }}</dd>
        }
        <dt>Brugere</dt>
        <dd>{{ summaryUsers() }}</dd>
        <dt>Advisering</dt>
        <dd>{{ config.delivery.advisering_enabled ? "Aktiv" : "Nej" }}</dd>
      </dl>
      <button mat-stroked-button class="cancel-btn" (click)="cancel()">
        Annuller
      </button>
    </aside>
  </div>
  } @if (loadingTypes && !selectedTypeDef) {
  <div class="generating-overlay">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Henter rapporttyper...</p>
  </div>
  } @if (isGenerating) {
  <div class="generating-overlay">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Rapporten genereres — det kan tage et øjeblik...</p>
  </div>
  }
</div>
